export default __webpack_public_path__ + "static/media/chevron_lefth.0f22652e.svg";